const normalizeValue = (value) => String(value || '').trim()

const normalizeForComparison = (value) => normalizeValue(value)
  .replace(/\s+/g, ' ')
  .toLowerCase()

const getStudentId = (student) => normalizeValue(
  student?.studentId || student?.studentID || student?.StudentID || student?.id
)

const getStudentName = (student) => normalizeValue(
  student?.studentName || student?.StudentName || student?.name
)

const findStudentNamedByEventTitle = (event, familyInfo) => {
  const eventTitle = normalizeForComparison(event?.name)
  if (!eventTitle) return null

  const familyName = normalizeValue(
    familyInfo?.familyName || familyInfo?.FamilyName || event?.familyName
  )

  return (Array.isArray(familyInfo?.students) ? familyInfo.students : []).find((student) => {
    const studentName = getStudentName(student)
    if (!studentName) return false

    const fullLessonName = familyName
      ? `${studentName} ${familyName}`
      : studentName

    return normalizeForComparison(eventTitle) === normalizeForComparison(fullLessonName)
      || normalizeForComparison(eventTitle) === normalizeForComparison(studentName)
  }) || null
}

export const findTimesheetStudent = (event, familyInfo) => {
  // Older events can have a visible title for one sibling while studentName and
  // studentId still point at another. An exact title match against the family
  // repairs that legacy case without trusting arbitrary free-form text.
  const titleMatch = findStudentNamedByEventTitle(event, familyInfo)
  if (titleMatch) return titleMatch

  const eventStudentId = normalizeValue(
    event?.studentId || event?.studentID || event?.StudentID
  )
  if (!eventStudentId) return null

  return (Array.isArray(familyInfo?.students) ? familyInfo.students : []).find(
    (student) => getStudentId(student) === eventStudentId
  ) || null
}

export const getTimesheetFamilyKey = (event) => {
  const familyId = normalizeValue(
    event?.familyId || event?.familyID || event?.FamilyID
  )
  if (familyId) return `id:${familyId}`

  return `name:${normalizeForComparison(event?.familyName)}`
}

export const createTimesheetLesson = (event, familyInfo, formatDate) => {
  const student = findTimesheetStudent(event, familyInfo)

  return {
    id: event?.lessonId,
    studentName: getStudentName(student) || normalizeValue(event?.studentName),
    lessonLength: event?.lessonLength,
    date: formatDate(new Date(event?.dateTime)),
    studentRate: student?.lessonRate ?? 0,
    studentAllRates: student?.allRates || { 15: 0, 30: 0, 45: 0, 60: 0 },
  }
}
